(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["fetch-plus-csrf"] = factory();
	else
		root["fetch-plus-csrf"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	var _compute = __webpack_require__(1);

	// Export using middleware direct notation.
	module.exports = function (headerName, currentValue) {
		return function (request) {
			if (currentValue) {
				request.options.headers[headerName] = (0, _compute.compute)(currentValue);
			}

			return function (response) {
				if (response.headers && response.headers.has && response.headers.has(headerName)) {
					currentValue = response.headers.get(headerName);
				}

				return response;
			};
		};
	}; /**
	    * @copyright © 2015, Rick Wong. All rights reserved.
	    */

/***/ },
/* 1 */
/***/ function(module, exports) {

	"use strict";

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

	/**
	 * @copyright © 2015, Rick Wong. All rights reserved.
	 */

	var _isScalar = function _isScalar(value) {
		return value === undefined || value === null || typeof value === "string" || typeof value === "number" || typeof value === "boolean";
	};

	var compute = function compute(value) {
		return typeof value === "function" ? value() : value;
	};

	var computeObject = function computeObject(object) {
		object = compute(object);

		if (_isScalar(object)) {
			return object;
		}

		var mapped = Array.isArray(object) ? [] : {};

		Object.keys(object).forEach(function (key) {
			var value = object[key];

			if (_isScalar(value)) {
				mapped[key] = value;
			} else if (((typeof FormData === "undefined" ? "undefined" : _typeof(FormData)) === "object" || typeof FormData === "function") && value instanceof FormData) {
				mapped[key] = value;
			} else if ((typeof value === "undefined" ? "undefined" : _typeof(value)) === "object") {
				mapped[key] = computeObject(value);
			} else {
				mapped[key] = compute(value);
			}
		});

		return mapped;
	};

	module.exports = {
		compute: compute,
		computeObject: computeObject
	};

/***/ }
/******/ ])
});
;